module.exports = __webpack_public_path__ + "static/freedom-of-speech-f99811dd5d0a849d5303f30da84b4aa9.jpg";